<template>
  <div>
    <h1>What We Do</h1>
    <p>We help governments, non-profits, corporations and community groups, find, processes, and use
    data to make informed strategic policies.</p>

    <b-row>
      <b-col>
        <b-card>
          <b-card-header>Consulting</b-card-header>
          <b-card-body>
            <ul>
              <li>Data Strategy</li>
              <li>Policy</li>
              <li>Racial Equity</li>
            </ul>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col>
        <b-card>
          <b-card-header>Research</b-card-header>
          <b-card-body>
            <li>Policy analysis</li>
            <li>Quantitative analysis</li>
            <li>Data collection</li>
            <li>Focus group facilitation</li>
            <li>Demographic Research</li>
            <li>Survey design</li>
            <li>Program evaluation</li>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col>
        <b-card>
          <b-card-header>Technology</b-card-header>
          <b-card-body>
            <li>Software Development</li>
            <li>Data Science</li>
            <li>Statistics</li>
            <li>Data Warehousing</li>
            <li>Data Migrations</li>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>


    Research design
    Data asset inventory
    Stakeholder interviews
    Qualitative analysis
    Research communication
    Demographic research
    Economic research
    Stakeholder education
    Data warehousing

  </div>
</template>
<script>
export default {
  methods: {
    track() {
      this.$ga.page('/about');
    },
  },
};
</script>
